import styled from "styled-components";

/** The card's shape, as CardPreview draws it, in the colors of the panel. */
export const CardShape = styled.figure`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 320px;
  aspect-ratio: 320 / 440;
  margin: 0 auto;
  padding: 24px;
  border-radius: 20px;
  background: var(--color-neutral-darkness);
  box-shadow: inset 0 0 0 1px var(--color-neutral-dark);

  .logo {
    align-self: flex-start;
    width: 64px;
    height: 20px;
  }

  .photo {
    width: 72px;
    height: 72px;
    margin-top: 20px;
    border-radius: 50%;
  }

  .name {
    width: 60%;
    height: 24px;
    margin-top: 16px;
  }

  .role {
    width: 45%;
    height: 14px;
    margin-top: 8px;
  }

  .qr {
    width: 132px;
    height: 132px;
    margin-top: auto;
    border-radius: 14px;
  }

  .url {
    width: 50%;
    height: 12px;
    margin-top: 12px;
  }
`;

/** The form's shape: its title, the labels of the fields over their boxes, the save button. */
export const FormShape = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .head {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .title {
    width: 180px;
    height: 16px;
  }

  .line {
    width: 70%;
    height: 12px;
  }

  .two {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0.75rem;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .label {
    width: 96px;
    height: 10px;
  }

  .input {
    height: 52px;
    border-radius: 10px;
  }

  .button {
    align-self: flex-end;
    width: 140px;
    height: 44px;
    border-radius: 100px;
  }
`;

/** The wallets' buttons under the card, side by side. */
export const WalletsShape = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;

  .wallet {
    width: 180px;
    height: 52px;
    border-radius: 12px;
  }
`;
